export function symbolToStr(symbol) {
    return symbol.description || symbol.toString().slice(7, -1);
}
//# sourceMappingURL=symbolToStr.js.map